const config = {
  key: "GPD2tA6B4B1C2C3F2F1lFe1a1PVWEc1Fd1XHTHc1THMMe1NCb1tA1A1A1B1H4B1B1B1A6D5==",
  attribution: false,
  // pastePlain: true,
  placeholderText: "Edit your content here.",
  toolbarButtons: {
    moreText: {
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikeThrough",
        "subscript",
        "superscript",
        "fontFamily",
        "fontSize",
        "textColor",
        "backgroundColor",
        "inlineClass",
        "inlineStyle",
        "clearFormatting",
      ],
    },
    moreParagraph: {
      buttons: [
        "alignLeft",
        "alignCenter",
        "formatOLSimple",
        "alignRight",
        "alignJustify",
        "formatOL",
        "formatUL",
        "paragraphFormat",
        "paragraphStyle",
        "lineHeight",
        "outdent",
        "indent",
        "quote",
      ],
    },
    moreRich: {
      buttons: [
        "insertLink",
        "insertImage",
        "insertVideo",
        "insertTable",
        "specialCharacters",
        "embedly",
        "insertFile",
        "insertHR",
      ],
    },
    moreMisc: {
      buttons: [
        "undo",
        "redo",
        "fullscreen",
        "print",
        "getPDF",
        "selectAll",
        "html",
        "help",
      ],
      align: "right",
      buttonsVisible: 2,
    },
  },
  toolbarStickyOffset: 64,
  quickInsertEnabled: false,
  fileUploadURL: process.env.VUE_APP_SERVER_ADDRESS + "/upload",
  imageUploadURL: process.env.VUE_APP_SERVER_ADDRESS + "/upload",
  videoUploadURL: process.env.VUE_APP_SERVER_ADDRESS + "/upload",
  fileMaxSize: 1024 * 1024 * 50,
  imageMaxSize: 1024 * 1024 * 50,
  charCounterMax: 65535,
  imageInsertButtons: ["imageBack", "|", "imageUpload", "imageByURL"],
  videoInsertButtons: [
    "videoBack",
    "|",
    "videoByURL",
    "videoEmbed",
    "videoUpload",
  ],
  requestHeaders: {
    Authorization: "Bearer " + window.localStorage.getItem("feathers-jwt"),
  },
  // Configure TUI Image Editor to use local SVG files
  imageTUIOptions: {
    includeUI: {
      initMenu: "filter",
      menuBarPosition: "left",
      theme: {
        "menu.activeIcon.path": "/svg/icon-b.svg",
        "menu.disabledIcon.path": "/svg/icon-a.svg",
        "menu.hoverIcon.path": "/svg/icon-c.svg",
        "menu.normalIcon.path": "/svg/icon-d.svg",
        "submenu.activeIcon.name": "icon-c",
        "submenu.activeIcon.path": "/svg/icon-c.svg",
        "submenu.normalIcon.name": "icon-d",
        "submenu.normalIcon.path": "/svg/icon-d.svg"
      }
    },
  }
};

export default config;
